import classNames from "classnames";
import React from "react";
import styles from "./PageHeader.scss";

import { Icon } from "../../graphic/Icon";
import { ContentWrapper } from "../../layout/ContentWrapper";
import { Choices } from "./parts/Choices";
import { Clickable } from "../../button/Clickable";
import { useNavigate } from "react-router-dom";

export const PageHeader = ({ icon, color, title, description, image, choices, pinned, backLink }) => {
    return (
        <div
            className={classNames(styles.base, {
                [styles.hasImage]: image,
                [styles.pinned]: pinned,
                [styles.colorError]: color === "error"
            })}
        >
            <div className={styles.bar}>
                <ContentWrapper>
                    <div className={styles.wrapper}>
                        <div className={styles.titles}>
                            {icon ? (
                                <IconButton icon={icon} backLink={backLink} />
                            ) : image ? (
                                <div className={styles.image}>{image}</div>
                            ) : null}
                            <div className={styles.title}>
                                {title}
                                {description ? <div className={styles.description}>{description}</div> : null}
                            </div>
                        </div>
                        {choices ? (
                            <div className={styles.choices}>
                                <Choices choices={choices} pinned={pinned} />
                            </div>
                        ) : null}
                    </div>
                </ContentWrapper>
            </div>
        </div>
    );
};

const IconButton = ({ icon, backLink }) => {
    const navigate = useNavigate();
    const iconBody = (
        <div
            className={classNames(styles.icon, {
                [styles.clickable]: backLink
            })}
        >
            <Icon name={icon} className={styles.mainIcon} />
            {backLink ? <Icon name="arrow-left" className={styles.arrowIcon} /> : null}
        </div>
    );

    if (!backLink) {
        return iconBody;
    }

    return <Clickable onClick={() => navigate(backLink)}>{iconBody}</Clickable>;
};

// TODO: Remove permanently if crumbs is not going back
// const Crumbs = ({ crumbs }) => {
//     return crumbs?.length ? (
//         <div className={styles.crumbs}>
//             <ContentWrapper>
//                 <Breadcrumbs>
//                     {crumbs.map((item, index) => (
//                         <Crumb key={index} label={item.label} text={item.text} link={item.link} />
//                     ))}
//                 </Breadcrumbs>
//             </ContentWrapper>
//         </div>
//     ) : null;
// };
